import React, { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../utils/firebase';

const AdminSubscriptionFix = () => {
  const [uid, setUid] = useState('');
  const [plan, setPlan] = useState('creator_pro');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const fixUserSubscription = httpsCallable(functions, 'fixUserSubscription');

  const handleFix = async () => {
    if (!uid.trim()) {
      setError('Please enter a user ID');
      return;
    }

    setLoading(true);
    setError(null);
    setResult(null);

    try {
      const result = await fixUserSubscription({
        uid: uid.trim(),
        plan: plan
      });

      setResult(result.data);
      console.log('✅ Subscription fixed:', result.data);
    } catch (error) {
      setError(error.message);
      console.error('❌ Error fixing subscription:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-gray-800 p-6 rounded-lg">
      <h3 className="text-xl font-bold text-white mb-4">🔧 Fix User Subscription</h3>
      
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">
            User ID
          </label>
          <input
            type="text"
            value={uid}
            onChange={(e) => setUid(e.target.value)}
            placeholder="Enter user UID"
            className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-md text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-300 mb-2">
            Plan
          </label>
          <select
            value={plan}
            onChange={(e) => setPlan(e.target.value)}
            className="w-full px-3 py-2 bg-gray-700 border border-gray-600 rounded-md text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="host">Host (Free)</option>
            <option value="creator_lite">Creator Lite ($60/month)</option>
            <option value="creator_pro">Creator Pro ($120/month)</option>
          </select>
        </div>

        <button
          onClick={handleFix}
          disabled={loading}
          className="w-full bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 text-white font-medium py-2 px-4 rounded-md transition-colors"
        >
          {loading ? 'Fixing...' : 'Fix Subscription'}
        </button>

        {error && (
          <div className="bg-red-900 border border-red-700 text-red-200 px-4 py-3 rounded-md">
            <strong>Error:</strong> {error}
          </div>
        )}

        {result && (
          <div className="bg-green-900 border border-green-700 text-green-200 px-4 py-3 rounded-md">
            <strong>Success!</strong> {result.message}
            <div className="mt-2 text-sm">
              <div>Plan: {result.data.plan}</div>
              <div>Launches: {result.data.entitlements.includedLaunches}</div>
              <div>Submissions: {result.data.entitlements.includedSubmissions}</div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminSubscriptionFix;



